import { Injectable } from '@angular/core';

import { NodePageData, ParagraphRelatedSolutionsData, SolutionsDataInner } from '@generated/content';
import { Card, CmsComponentConfig, RelatedSolutions } from '@interfaces/config';
import { CmsComponentNodeData } from '@interfaces/index';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';
import { CardComponentResolver } from '@services/resolvers/component-resolvers/card-component/card-component-resolver';

@Injectable({ providedIn: 'root' })
export class RelatedSolutionsComponentResolver extends BaseComponentResolver {
  static override instance: RelatedSolutionsComponentResolver;
  private readonly componentType = RelatedSolutions.TypeEnum;

  static getInstance(): RelatedSolutionsComponentResolver {
    return (RelatedSolutionsComponentResolver.instance ||= new RelatedSolutionsComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphRelatedSolutionsData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<RelatedSolutions.ComponentConfig> | null {
    if (!node) {
      return null;
    }

    this.nodePageData = nodePageData;

    const items = this.getSolutions(node.relationships.field_solutions?.data || []);

    return {
      componentType: this.componentType,
      config: { nodeId: BaseComponentResolver.getNodeId(node), items },
    };
  }

  private getSolutions(solutions: SolutionsDataInner[]): Card.ComponentConfig[] | null {
    return solutions.reduce((p, c) => {
      const node = this.getNode<NodePageData>(c.id, c.type);

      if (!node) {
        return p;
      }

      const cardConfig: Card.ComponentConfig = CardComponentResolver.getCardConfig<NodePageData>(node, this.nodePageData);

      if (!cardConfig.link.text) {
        cardConfig.link.text = 'Learn more';
      }

      return [...p, cardConfig];
    }, []);
  }
}
